import React from 'react';

function Impressum() {
  return (
    <section style={{ paddingTop: 'calc(var(--nav-height) + 2rem)' }}>
      <div className="container">
        <h1>Impressum</h1>
        
        <p><strong>Angaben gemäß § 5 TMG</strong></p>
        <p>
          FH Consulting<br />
          Inhaber: Florian Huber<br />
          Bauernfeindstraße 8<br />
          80939 München<br />
          Deutschland
        </p>
        
        <p>
          <strong>Kontakt:</strong><br />
          Telefon: +49 1529 2608956<br />
          E-Mail: <a href="mailto:info@fh-consulting.de">info@fh-consulting.de</a><br />
          Internet: <a href="http://www.fh-consulting.de" target="_blank" rel="noopener noreferrer">www.fh-consulting.de</a>
        </p>
        
        <p>
          <strong>Umsatzsteuer-ID:</strong><br />
          Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz: beantragt
        </p>
        
        <p>
          <strong>Aufsichtsbehörde:</strong><br />
          Industrie- und Handelskammer für München und Oberbayern<br />
          Max-Joseph-Straße 2, 80333 München<br />
          <a href="https://www.ihk-muenchen.de" target="_blank" rel="noopener noreferrer">www.ihk-muenchen.de</a>
        </p>
      </div>
    </section>
  );
}

export default Impressum;
